import { useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints({
  mobile: 321,
  tablet: 769,
  laptop: 1151,
})

const smallerThanLaptop = breakpoints.smaller('laptop')

export { breakpoints, smallerThanLaptop }
